import { css } from "@emotion/css";
import { DateTime } from "luxon";

import { useStyles } from "@/hooks/useStyles.ts";
import { InsulinInjectionMethod } from "@/models/InsulinStatsModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { GlycemiaStatsCGM } from "@/uiKit/organisms/DiabetesStats/GlycemiaStatsCGM.tsx";
import { InsulinPumpSettings } from "@/uiKit/organisms/DiabetesStats/InsulinPumpSettings.tsx";
import {
  InsulinStatsCGMContinuous,
  InsulinStatsCGMDiscrete,
} from "@/uiKit/organisms/DiabetesStats/InsulinStatsCGM.tsx";

type DiabetesStatsProps = {
  patientId: string;
  to: DateTime;
  from: DateTime;
  insulinInjectionMethod?: InsulinInjectionMethod;
  closedLoop: boolean;
};

export const DiabetesStatsCGM = ({ patientId, from, to, insulinInjectionMethod, closedLoop }: DiabetesStatsProps) => {
  const devices = Queries.diabetes.useMedicalDevices(patientId);

  const styles = useStyles(makeStyles);

  return (
    <div className={styles.container}>
      <GlycemiaStatsCGM patientId={patientId} from={from} to={to} />
      {insulinInjectionMethod === "pump" && (
        <InsulinStatsCGMContinuous patientId={patientId} from={from} to={to} closedLoop={closedLoop} />
      )}
      {insulinInjectionMethod === "pen" && <InsulinStatsCGMDiscrete patientId={patientId} from={from} to={to} />}
      {insulinInjectionMethod === "pump" && <InsulinPumpSettings devices={devices} />}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    gap: ${theme.spacing(8)};
    flex-direction: column;
  `,
});
